import { put, call, take, fork } from 'redux-saga/effects'
import { getCourseLandingPageSuccess } from 'src/reducers/course/action'
import { getCourseLandingPageService } from 'src/api/course'
import { GET_COURSE_LANDING_PAGE } from 'src/reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* getCourseLandingPage(payload) {
  try {
    const { id, callback } = payload
    const response = yield call(getCourseLandingPageService, id)

    yield put(getCourseLandingPageSuccess(response.data))
    yield put(operationSuccess())

    if (callback) callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* getCourseLandingPageWatcher() {
  while (true) {
    const action = yield take(GET_COURSE_LANDING_PAGE)
    const { payload } = action

    yield fork(generalSaga, getCourseLandingPage, payload)
  }
}
